import apiUrl from '../../../constants';
import JsonCSV from 'vue-json-csv';
import axios from 'axios';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
//import GetData from '../../../services/getDataClass';
import Paginate from 'vuejs-paginate';
import { removeSalesDemoService } from '../../../services/removeSalesDemo';


export default {
    name: 'investigationdashboard',
    props: ['rootMethods'],
    components: {
        Paginate,
        VueElementLoading,
        'download-csv': JsonCSV
    },
    data() {
        return {
            show: false,
            fromdate: '',
            todate: '',
            manifestFromDate: '',
            manifestToDate: '',
            investigationStatus: 'open',
            currentdateminus180: '',
            currentdate:'',
            datetime180:'',
            loadingResult: false,
            datetime:'',
            newhublist: [],
            zone: '',
            daysto:'',
            d:'',

            //tokan
            myStr: '',

            //clt shipment
            shipmentCLT: [],

            //Operation
            shipmentOperation: [],

            //Security
            shipmentSecurity: [],

            //Finance
            shipmentFinance: [],

            // role check
            role: '',
            showtableclt: false,
            showtableoperation: false,
            showtablefiance: false,
            showtablesequrity: false,
            hubdroplist: [],
            List: [],
            ListData: [],
            mappingList: {},
            CSVDataArray: [],
            hasSearched: true,
            // csvFilename: 'dashboard-shipment-data',
        }

    },
    mounted() {    
        var userToken = window.localStorage.getItem('accessuserToken');
        this.getMapping();
        this.myStr = userToken.replace(/"/g, '');
        this.role = window.localStorage.getItem('accessrole').toLowerCase().replace(/\s/g, '');
        this.getzonehubs();
        this.gethubdropdown();

        //Fetching All dashboards without access restictions
        this.getshipmentCLT();
        this.getshipmentOperation();
        this.getshipmentSecurity();
        this.getshipmentFinance();
    },
    methods: {
        // Getting mapping list from common function object
        async getMapping(){
            this.mappingList = await this.rootMethods();
            console.log("this.mappingList: ", this.mappingList);
        },
        formatDate(date) {
            const pad = (n) => String(n).padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
                `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        },
        setDefaultDateRange() {
            const now = new Date();
            const minus180 = new Date();
            minus180.setDate(minus180.getDate() - 180);
            this.datetime = this.formatDate(now);
            this.datetime180 = this.formatDate(minus180);
        },
        validateSearchFilters() {
            if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
                this.$alertify.error("Please enter both investigation logged dates");
                return false;
            }
            if (this.fromdate > this.todate) {
                this.$alertify.error("From date should not be greater than To date");
                return false;
            }
            if ((this.manifestFromDate && !this.manifestToDate) || (!this.manifestFromDate && this.manifestToDate)) {
                this.$alertify.error("Please enter both manifest dates");
                return false;
            }
            if (this.manifestFromDate > this.manifestToDate) {
                this.$alertify.error("Manifest from date should not be greater than To date");
                return false;
            }
            return true;
        },
        buildDashboardPayload(extraPayload = {}) {
            this.setDefaultDateRange();
            const payload = Object.assign({
                fromdate: this.fromdate && this.todate ? this.fromdate.slice(0,10) + " 00:00:00" : this.datetime180,
                todate: this.fromdate && this.todate ? this.todate.slice(0,10) + " 23:59:59" : this.datetime
            }, extraPayload);

            if (this.manifestFromDate && this.manifestToDate) {
                payload.frommanifesteddate = this.manifestFromDate.slice(0,10) + " 00:00:00";
                payload.tomanifesteddate = this.manifestToDate.slice(0,10) + " 23:59:59";
            }

            if (this.investigationStatus !== '') {
                payload.investigationstatus = this.investigationStatus === 'open';
            }

            return payload;
        },
        searchDashboard() {
            if (!this.validateSearchFilters()) {
                return;
            }
            this.hasSearched = true;
            this.getshipmentCLT();
            this.getshipmentOperation();
            this.getshipmentSecurity();
            this.getshipmentFinance();
        },

        //for zone list
        getzonehubs() {
            this.show = true;
            axios({
                method: 'post',
                url: apiUrl.api_url + 'getZoneList',
                data: {},
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                this.show = false;
                let finalHubData = []
                result.data.data.forEach((hub) => {
                    finalHubData.push({
                        id: hub.hubzoneid,
                        label: hub.hubzonename
                    })
                })
                this.newhublist = finalHubData;
            })
        },

        // for clt shipment
        getshipmentCLT() {
            this.input = this.buildDashboardPayload();
            axios({
                method: 'post',
                url: apiUrl.api_url + 'investigateshipmentdetailsdashboardclt',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                this.show = false;
                var cltshipment = [];
                    this.showtableclt = true;
                    result.data.data.forEach((clt) => {
                        cltshipment.push({
                            dispute: clt.dispute,
                            std: clt.std,
                            shortage: clt.shortage,
                            hubzoneid: clt.hubzoneid,
                            rtodispute: clt.rtodispute,
                            totalshippingid: clt.totalshippingid,
                            isshortage: clt.isshortage,
                            isrtodispute: clt.isrtodispute,
                            isdispute: clt.isdispute,
                            istd: clt.istd,
                            hvtexp: clt.hvtexp,
                            forcefullylost: clt.forcefullylost,
                            forcefullylost_rto: clt.forcefullylost_rto,
                            forwarddispute: clt.forwarddispute,
                            declaredvalue: clt.declaredvalue,
                            nts: clt.nts,
                            dtodispute: clt.dtodispute,
                            whhandoverdispute: clt.whhandoverdispute,
                            clientdebit:clt.clientdebit
                        })
                    });
                    var cltshipment1 = [];
                    for (let i = 0; i < cltshipment.length; i++) {
                        if (cltshipment[i]["hubzoneid"] != null) {
                            cltshipment1.push(cltshipment[i]);
                        }
                    }
                    cltshipment = cltshipment1;
                    for (let i = 0; i < cltshipment.length; i++) {
                        for (let j = 0; j < this.newhublist.length; j++) {
                            if ((cltshipment[i]["hubzoneid"] == this.newhublist[j]["id"])) {
                                cltshipment[i]["hubzonename"] = this.newhublist[j]["label"];
                            }

                        }
                    }
                    if (cltshipment.length > 0) {
                        let ctlKeys = Object.keys(cltshipment[0]);
                        console.log(ctlKeys,"hiiiiiii");

                        let displayArr = {};
                        let colTotal = 0;
                        for (let i = 0; i < ctlKeys.length; i++) {
                            colTotal = 0;
                            if (ctlKeys[i] != "hubzoneid" && ctlKeys[i] != "hubzonename") {

                                for (let j = 0; j < cltshipment.length; j++) {
                                    colTotal += +cltshipment[j][ctlKeys[i]];
                                }
                                if (ctlKeys[i] == "declaredvalue") {
                                    displayArr[ctlKeys[i]] = colTotal.toFixed(2);

                                }
                                else {
                                    displayArr[ctlKeys[i]] = colTotal;

                                }

                            }
                        }
                        displayArr["hubzoneid"] = null;
                        displayArr["hubzonename"] = "Total";
                        cltshipment.push(displayArr);
                    }
                    this.shipmentCLT = cltshipment;
            },
            error => {
                console.error(error)
            })
        },

        //for Operation shipment
        getshipmentOperation() {
            this.input = this.buildDashboardPayload();
            axios({
                method: 'post',
                url: apiUrl.api_url + 'investigateshipmentdetailsdashboardoperation',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                    var opeshipment = [];
                    this.showtableoperation = true;
                    result.data.data.forEach((opration) => {
                        opeshipment.push({
                            dispute: opration.dispute,
                            std: opration.std,
                            shortage: opration.shortage,
                            hubzoneid: opration.hubzoneid,
                            rtodispute: opration.rtodispute,
                            totalshippingid: opration.totalshippingid,
                            isshortage: opration.isshortage,
                            isrtodispute: opration.isrtodispute,
                            isdispute: opration.isdispute,
                            istd: opration.istd,
                            hvtexp: opration.hvtexp,
                            forcefullylost: opration.forcefullylost,
                            forcefullylost_rto: opration.forcefullylost_rto,
                            forwarddispute: opration.forwarddispute,
                            declaredvalue: opration.declaredvalue,
                            nts: opration.nts,
                            dtodispute: opration.dtodispute,
                            whhandoverdispute: opration.whhandoverdispute,
                            clientdebit:opration.clientdebit

                        })
                    });
                    var opeshipment1 = [];
                    for(let i = 0; i < opeshipment.length; i++){
                        if(opeshipment[i]["hubzoneid"]!=null){
                            opeshipment1.push(opeshipment[i]);
                        }
                    }
                    opeshipment=opeshipment1;
                    for (let i = 0; i < opeshipment.length; i++) {
                        for (let j = 0; j < this.newhublist.length; j++) {
                            if (opeshipment[i]["hubzoneid"] == this.newhublist[j]["id"]) {
                                opeshipment[i]["hubzonename"] = this.newhublist[j]["label"]

                            }
                        }
                    }
                    if (opeshipment.length > 0) {

                        let ctlKeys = Object.keys(opeshipment[0]);
                        let displayArr = {};
                        let colTotal = 0;
                        for (let i = 0; i < ctlKeys.length; i++) {
                            colTotal = 0;
                            if (ctlKeys[i] != "hubzoneid" && ctlKeys[i] != "hubzonename") {
                                for (let j = 0; j < opeshipment.length; j++) {
                                    colTotal += +opeshipment[j][ctlKeys[i]];
                                }
                                if (ctlKeys[i] == "declaredvalue") {
                                    displayArr[ctlKeys[i]] = colTotal.toFixed(2);
                                }
                                else {
                                    displayArr[ctlKeys[i]] = colTotal;

                                }
                            }
                        }
                        displayArr["hubzoneid"] = null;
                        displayArr["hubzonename"] = "Total";

                        opeshipment.push(displayArr);

                    }

                    this.shipmentOperation = opeshipment;

            },
                error => {
                    this.show = false;
                    console.error(error)
                })
        },

        //for Security shipment
        getshipmentSecurity() {
            this.input = this.buildDashboardPayload();
            axios({
                method: 'post',
                url: apiUrl.api_url + 'investigateshipmentdetailsdashboardsecurity',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                var seqshipment = [];

                this.showtablesequrity = true;

                result.data.data.forEach((security) => {
                    seqshipment.push({
                        dispute: security.dispute,
                        std: security.std,
                        shortage: security.shortage,
                        hubzoneid: security.hubzoneid,
                        rtodispute: security.rtodispute,
                        totalshippingid: security.totalshippingid,
                        isshortage: security.isshortage,
                        isrtodispute: security.isrtodispute,
                        isdispute: security.isdispute,
                        istd: security.istd,
                        hvtexp: security.hvtexp,
                        forcefullylost: security.forcefullylost,
                        forcefullylost_rto: security.forcefullylost_rto,
                        forwarddispute: security.forwarddispute,
                        declaredvalue: security.declaredvalue,
                        nts: security.nts,
                        dtodispute: security.dtodispute,
                        whhandoverdispute: security.whhandoverdispute,
                        clientdebit:security.clientdebit
                    })
                });
                var seqshipment1 = [];
                    for (let i = 0; i < seqshipment.length; i++) {
                        if (seqshipment[i]["hubzoneid"] != null) {
                            seqshipment1.push(seqshipment[i]);
                        }
                    }
                    seqshipment = seqshipment1;
                for (let i = 0; i < seqshipment.length; i++) {
                    for (let j = 0; j < this.newhublist.length; j++) {
                        if (seqshipment[i]["hubzoneid"] == this.newhublist[j]["id"]) {
                            seqshipment[i]["hubzonename"] = this.newhublist[j]["label"]
                        }
                    }
                }
                if (seqshipment.length > 0) {
                    let ctlKeys = Object.keys(seqshipment[0]);
                    let displayArr = {};
                    let colTotal = 0;
                    for (let i = 0; i < ctlKeys.length; i++) {
                        colTotal = 0;
                        if (ctlKeys[i] != "hubzoneid" && ctlKeys[i] != "hubzonename") {

                            for (let j = 0; j < seqshipment.length; j++) {
                                colTotal += +seqshipment[j][ctlKeys[i]];
                            }
                            if (ctlKeys[i] == "declaredvalue") {
                                displayArr[ctlKeys[i]] = colTotal.toFixed(2);

                            }
                            else {
                                displayArr[ctlKeys[i]] = colTotal;

                            }

                        }
                    }
                    displayArr["hubzoneid"] = null;
                    displayArr["hubzonename"] = "Total";
                    seqshipment.push(displayArr);
                }
                this.shipmentSecurity = seqshipment;
            },
                error => {
                    console.error(error)
                })
        },

        //for Finance shipment
        getshipmentFinance() {
            this.input = this.buildDashboardPayload();
            axios({
                method: 'post',
                url: apiUrl.api_url + 'investigateshipmentdetailsdashboardfinance',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                var financeshipment = [];
                this.showtablefiance = true;
                result.data.data.forEach((finance) => {
                    financeshipment.push({
                        dispute: finance.dispute,
                        std: finance.std,
                        shortage: finance.shortage,
                        hubzoneid: finance.hubzoneid,
                        rtodispute: finance.rtodispute,
                        totalshippingid: finance.totalshippingid,
                        isshortage: finance.isshortage,
                        isrtodispute: finance.isrtodispute,
                        isdispute: finance.isdispute,
                        istd: finance.istd,
                        hvtexp: finance.hvtexp,
                        forcefullylost: finance.forcefullylost,
                        forcefullylost_rto: finance.forcefullylost_rto,
                        forwarddispute: finance.forwarddispute,
                        declaredvalue: finance.declaredvalue,
                        nts: finance.nts,
                        dtodispute: finance.dtodispute,
                        whhandoverdispute: finance.whhandoverdispute,
                        clientdebit:finance.clientdebit
                    })
                });
                var financeshipment1 = [];
                for (let i = 0; i < financeshipment.length; i++) {
                    if (financeshipment[i]["hubzoneid"] != null) {
                        financeshipment1.push(financeshipment[i]);
                    }
                }
                financeshipment = financeshipment1;
                for (let i = 0; i < financeshipment.length; i++) {
                    for (let j = 0; j < this.newhublist.length; j++) {
                        if (financeshipment[i]["hubzoneid"] == this.newhublist[j]["id"]) {
                            financeshipment[i]["hubzonename"] = this.newhublist[j]["label"]
                        }
                    }
                }
                if (financeshipment.length > 0) {
                    let ctlKeys = Object.keys(financeshipment[0]);
                    let displayArr = {};
                    let colTotal = 0;
                    for (let i = 0; i < ctlKeys.length; i++) {
                        colTotal = 0;
                        if (ctlKeys[i] != "hubzoneid" && ctlKeys[i] != "hubzonename") {
                            for (let j = 0; j < financeshipment.length; j++) {
                                colTotal += +financeshipment[j][ctlKeys[i]];
                            }
                            if (ctlKeys[i] == "declaredvalue") {
                                displayArr[ctlKeys[i]] = colTotal.toFixed(2);
                            }
                            else {
                                displayArr[ctlKeys[i]] = colTotal;
                            }
                        }
                    }
                    displayArr["hubzoneid"] = null;
                    displayArr["hubzonename"] = "Total";
                    financeshipment.push(displayArr);
                }
                this.shipmentFinance = financeshipment;
            },
                error => {
                    console.error(error)
                })
        },
        resetForm() {

            this.shipmentCLT = [];
            this.shipmentOperation = [];
            this.shipmentSecurity = [];
            this.shipmentFinance = [];
            this.todate = this.fromdate = this.manifestFromDate = this.manifestToDate = '';
            this.investigationStatus = 'open';
            this.hasSearched = false;
            this.$validator.reset();

        },
        gethubdropdown() {
            axios({
                method: 'post',
                url: apiUrl.api_url + 'getHubdropdownlist',
                data: {},
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                let finalHubData = []
                result.data.data.forEach((hub) => {
                    finalHubData.push({
                        id: hub.HubID,
                        label: hub.HubName
                    })
                })
                this.hubdroplist = finalHubData;
                this.editshowtable = false;
                this.editshowtable = true;

            },
                error => {
                    console.error(error)
                })
        },
        buckettypecode() {

            axios({
                method: 'post',
                url: apiUrl.api_url + 'getinvestigationbuckettype',
                data: {},
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }

            }).then(result => {
                this.ListData = result.data.data;
                this.editshowtable = false;
                this.editshowtable = true;
            },
                error => {
                    this.show = false;
                    console.error(error)
                })
        },
        disputstatus() {
            axios({
              method: 'post',
              url: apiUrl.api_url + 'DisputeSubStatus',
              data: {},
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              }

            }).then(result => {
              this.subStatusList = result.data.data;
            },
              error => {
                console.error(error)
              })
          },
          
          csvFilieName(bucketId) {
            let bucketName;
            switch(bucketId){
                case '1':
                bucketName = 'Opration';
                break;
                case '2':
                bucketName = 'CLT';
                break;
                case '3':
                bucketName = 'Security';
                break;
                case '4':
                bucketName = 'Finance';
                break;
                default:
                bucketName = 'No Bucket';
                break;
            }
            return bucketName+moment(new Date).format("YYYY-MM-DD HH:mm:ss.SSS")+".csv";
        },

        exportDataCSV(hubid,bucketId,status) {
            this.loadingResult = true;
            this.input = this.buildDashboardPayload({
                status: status,
                bucketid: bucketId,
                hubzoneid: hubid,
            });
            axios({
                method: 'post',
                url: apiUrl.api_url + 'csvDownload',
                data: this.input,
                responseType: "arraybuffer",
                headers: {
                    'Authorization': 'Bearer ' + this.myStr,
                    'Content-type': 'application/json'
                }
            }).then(result => {
                if(result.data === ''){
                    this.$alertify.error("No data Found");
                    this.loadingResult = false;
                    return;
                }
                const url = window.URL.createObjectURL(new Blob([result.data],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));                
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.csvFilieName(bucketId));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.loadingResult = false;
                this.$alertify.success("Success");
            },
            error => {
                console.error(error)
            });
        },

        removeSalesDemo(){
            swal({
                title: "Are you sure?",
                text: `you want to remove all the sales demo shipments ?`,
                icon: "warning",
                buttons: true,
                dangerMode: true,
              }).then((willDelete) => {
                  if(willDelete){
                    removeSalesDemoService(this.myStr).then(result => {
                        if(result.data.ReturnCode === 100){
                            getshipmentCLT(); getshipmentOperation();getshipmentSecurity();getshipmentFinance();
                            swal("Shipments are removed successfully", {icon: "success"});
                            return;
                        }
                        swal("Something went wrong, could not remove shipments.", {icon: "error"});
                    });
                }
              });
        }
    },
}



// WEBPACK FOOTER //
// ./src/views/components/dashboard/dashboard.component.js